import { gql, useMutation } from "@apollo/client";
import React, { useState } from "react";
import { Button, Form, Grid, Icon, Segment } from "semantic-ui-react";
import Swal from "sweetalert2";
import LOGO_MULTI from "../../assets/logo-multi.png";
import { EMAIL_REGEX } from "../../Utils/Constants";
const RecoverAccount = ({ history }) => {
  const [email, setEmail] = useState('');
  const [sendEmail, setSendEmail] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleBackToLogin = () => {
    history.replace("/");
    setSendEmail(false);
  }

  const onCompleted = () => {
    setLoading(false);
    setSendEmail(true);
  }

  const onError = ({ graphQLErrors }) => {
    setLoading(false);
    if (graphQLErrors) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: graphQLErrors[0]?.message
      });
    } else {
      Swal.fire("Lo sentimos, ha ocurrido un error.");
    }
  };

  const [mutation] = useMutation(RECOVER_ACCOUNT, { onCompleted, onError });
  const handleMutation = () => {
    setLoading(true);
    mutation({ variables: { email: email.trim() } });
  }
  return (
    <Grid className="login" textAlign='center' style={{ height: '100vh' }} verticalAlign='middle'>
      <Grid.Column style={{ maxWidth: 450 }}>
        <Form size='large'>
          <Segment stacked>
            <div style={{ textAlign: 'center' }}>
              <img src={LOGO_MULTI} alt="logo multidiomas" />
            </div>
            <h3>Recuperar cuenta</h3>
            {!sendEmail && (
              <>
                <p style={{ fontWeight: 'bold' }}>Ingresa tu correo electrónico para buscar tu cuenta.</p>
                <Form.Input
                  icon={<Icon name='user' style={{ color: '#B0193F' }} />}
                  value={email}
                  error={email.trim() ? !EMAIL_REGEX.test(email) : null}
                  iconPosition='left'
                  placeholder='Correo'
                  onChange={(e, { value }) => setEmail(value)} />
                <Button
                  onClick={handleMutation}
                  loading={loading}
                  style={{ backgroundColor: '#B0193F', color: '#fff' }}
                  disabled={!EMAIL_REGEX.test(email) || loading}>
                  Enviar
                </Button>
              </>
            )}
            {sendEmail && (
              <p style={{ fontWeight: 'bold' }}>
                Hemos enviado un enlace para recuperar tu cuenta al correo que nos has proporcionado.
              </p>
            )}
            <Button
              onClick={handleBackToLogin}
              style={{ backgroundColor: '#B0193F', color: '#fff' }}>
              volver
            </Button>
          </Segment>
        </Form>
      </Grid.Column>
    </Grid>
  );
}

const RECOVER_ACCOUNT = gql`
  mutation recoverPassword($email: EmailAddress!) {
    recuperarCuenta(email: $email)
  }
`;

export default RecoverAccount;